import * as distance from '~/constants/distance';

export type JSONCarrierParcelTemplate = {
  name: string;
  distance_unit: string;
  height: string;
  length: string;
  width: string;
  token: string;
  provider: string;
  is_variable_dimensions: boolean;
};

type CarrierParcelTemplate = {
  name: string;
  distanceUnit: distance.DistanceUnit;
  height: number;
  length: number;
  width: number;
  token: string;
  provider: string;
  isVariableDimensions: boolean;
};

export type WebCarrierParcelTemplate = {
  api_token: string;
  distance_unit: distance.DistanceUnit;
  height: string;
  is_variable_dimensions: boolean;
  length: string;
  name: string;
  carrier: string;
  token: string;
  width: string;
};

const unitValue: CarrierParcelTemplate = {
  name: '',
  distanceUnit: distance.DistanceUnit.IN,
  height: 0,
  length: 0,
  width: 0,
  token: '',
  provider: '',
  isVariableDimensions: false,
};

export function fromJSON(
  jsonCarrierParcelTemplate: Maybe<JSONCarrierParcelTemplate>,
): Maybe<CarrierParcelTemplate> {
  if (!jsonCarrierParcelTemplate) return null;

  return {
    name: jsonCarrierParcelTemplate.name,
    distanceUnit: distance.distanceUnitMap[jsonCarrierParcelTemplate.distance_unit],
    height: Number(jsonCarrierParcelTemplate.height),
    length: Number(jsonCarrierParcelTemplate.length),
    width: Number(jsonCarrierParcelTemplate.width),
    token: jsonCarrierParcelTemplate.token,
    provider: jsonCarrierParcelTemplate.provider,
    isVariableDimensions: jsonCarrierParcelTemplate.is_variable_dimensions,
  };
}

export function toJSON(carrierParcelTemplate: CarrierParcelTemplate): JSONCarrierParcelTemplate {
  return {
    name: carrierParcelTemplate.name,
    distance_unit: carrierParcelTemplate.distanceUnit,
    height: carrierParcelTemplate.height.toString(),
    length: carrierParcelTemplate.length.toString(),
    width: carrierParcelTemplate.width.toString(),
    token: carrierParcelTemplate.token,
    provider: carrierParcelTemplate.provider,
    is_variable_dimensions: carrierParcelTemplate.isVariableDimensions,
  };
}

export const fromWebCarrierParcelTemplate = (
  template?: WebCarrierParcelTemplate,
): CarrierParcelTemplate => {
  if (!template) {
    return unitValue;
  }

  return {
    name: template.name,
    distanceUnit: template.distance_unit,
    height: Number(template.height),
    length: Number(template.length),
    width: Number(template.width),
    token: template.token,
    provider: template.carrier,
    isVariableDimensions: template.is_variable_dimensions,
  };
};

export default CarrierParcelTemplate;
